export const ALLOW_EMAIL_COOKIE = 'hub$allow_email';
